export const globalKey = (...components: unknown[]): string => {
  return components.map((c) => `${c}`).join("/");
};

export const localKey = (...components: unknown[]): string => {
  return [...components, new Date().getTime(), Math.random()]
    .map((c) => `${c}`)
    .join("/");
};
